import React from 'react';
import {
    Button, withStyles, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Badge, Typography
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { getWorkerTasks, getAllInvolvedUsers, getUsersProjects, getAssignedTasks, prepareFilters } from '../../firebase/db/tasks';
import { connect } from 'react-redux';
import { Base64 } from 'js-base64';
import _ from 'lodash';
import Select from 'react-select';
import { DateRangePicker } from 'react-dates';
import OverlayContainer from '../Overlay/OverlayContainer';
import { toast } from 'react-toastify';
import LoadingProgress from '../common/LoadingProgress';

const CustomTableCell = withStyles(theme => ({
    head: {
        backgroundColor: '#f2f2f2',
        color: theme.palette.common.black,
        height: '45px',
        fontWeight: '400',
        fontSize: 17
    },
    body: {
        fontSize: 14,
    },
    root: {
        padding: '5px',
        textAlign: 'left',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        verticalAlign: 'inherit'
    }
}))(TableCell);

const styles = theme => ({
    filter: {
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-between',
    },
    picker: {
        // borderRadius: '2px',
        // border: '1px solid'
    },
    container: {
        margin: '3% 3% 3% 3%'
    },
    editButton: {
        display: 'flex',
        flexDirection: 'row'
    },
    docContainer: {
        display: 'flex',
        flexFlow: 'row wrap'
    },
    select: {
        minWidth: '200px',
        marginRight: '10px',
        borderRadius: 0,
        fontFamily: '-apple-system,system-ui,BlinkMacSystemFont,' + "'Roboto', sans-serif",
    },
    textName: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: 1,
        WebkitBoxOrient: 'vertical',
        paddingTop: '50px',
        fontSize: 14,
        width: 105
    },
    actions: {
        display: 'flex',
        flexDirection: 'row-reverse'
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    tasksContainer: {
        display: 'flex',
        flexDirection: 'column',
    },
    table: {
        minWidth: 700,
        marginTop: 40
    },
    badge: {
        marginLeft: 20
    }
});
class TasksDashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedProject: null,
            selectedCycle: null,
            selectedTask: null,
            role: '',
            tasks: [],
            filteredTasks: [],
            filtering: true,
            projects: [],
            cycles: [],
            workers: [],
            startDate: null,
            endDate: null,
            state: [{ label: 'Open', value: false },
            { label: 'Finished', value: true },
            { label: 'In Progress', value: 0 },
            ],
        };
    }

    componentDidMount() {
        const { auth } = this.props;
        getUsersProjects(auth.email)
            .then((projects) => {
                getAllInvolvedUsers(auth.email)
                    .then((users) => {
                        let uniqueUserRoles = _.uniqWith(users, _.isEqual)
                        let uniqueProjects = _.uniqWith(projects, _.isEqual);
                        uniqueUserRoles.map((user) => {
                            if (user && Object.values(user)[0][0] === 'manager' || Object.values(user)[0][0] === 'co-manager') {
                                getAssignedTasks(uniqueProjects)
                                    .then((tasks) => {
                                        let initialFilter = tasks.filter((t) => !t.subTask.finished)
                                        this.setState((state) => {
                                            return { tasks: [...state.tasks, ...tasks], filteredTasks: [...state.filteredTasks, ...initialFilter] }
                                        }, () => {
                                            prepareFilters(this.state.tasks)
                                                .then(filters => {
                                                    const [projects, cycles, workers] = filters;
                                                    this.setState({ projects, cycles: cycles.filter(c => c), workers });
                                                });
                                        });
                                    })
                            }
                        })
                        this.setState({
                            userRoles: uniqueUserRoles
                        })
                    })
                getWorkerTasks(auth.email)
                    .then((tasks) => {
                        let initialFilter = tasks.filter((t) => !t.subTask.finished)
                        this.setState((state) => {
                            return { tasks: [...state.tasks, ...tasks], filteredTasks: [...state.filteredTasks, ...initialFilter] }
                        }, () => {
                            prepareFilters(this.state.tasks)
                                .then(filters => {
                                    const [projects, cycles, workers] = filters;
                                    this.setState({ projects, cycles: cycles.filter(c => c), workers, filtering: false });
                                });
                        });
                    });
                if (this.props.location.state) {
                    this.setState({
                        filtering: true
                    })
                }
                if (this.props.location.state && this.props.location.state.projectId && !this.props.location.state.cycleId && !this.props.location.state.assignedTo) {
                    setTimeout(() => {
                        this.setState({
                            projectId: this.props.location.state.projectId
                        }, () => {
                            this.initialFilter();
                        })
                    }, 2000);
                } else if (this.props.location.state && this.props.location.state.projectId && this.props.location.state.cycleId && !this.props.location.state.assignedTo) {
                    setTimeout(() => {
                        this.setState({
                            projectId: this.props.location.state.projectId,
                            cycleId: this.props.location.state.cycleId
                        }, () => {
                            this.initialFilter();
                        })
                    }, 2000);
                } else if (this.props.location.state && this.props.location.state.assignedTo && !this.props.location.state.cycleId && this.props.location.state.projectId) {
                    setTimeout(() => {
                        this.setState({
                            projectId: this.props.location.state.projectId,
                            assignedTo: this.props.location.state.assignedTo,
                        }, () => {
                            this.initialFilter();
                        })
                    }, 2000);
                }
            })
    }

    onEditClick = (row, title, manager, members, worker) => {
        const { history, auth } = this.props;
        if (worker === window.btoa(auth.email) && manager !== window.btoa(auth.email) && members[window.btoa(auth.email)] !== 'manager') {
            this.setState({ selectedProject: row.subTask.project, selectedCycle: row.subTask.cycle, selectedTask: row.subTask.task, role: 'worker', row, title })
        } else {
            this.setState({ selectedProject: row.subTask.project, selectedCycle: row.subTask.cycle, selectedTask: row.subTask.task, role: 'manager' })
        }
    }

    initialFilter() {
        const { tasks, projectId, cycleId, assignedTo } = this.state;
        let forFilter = tasks.filter((t) => !t.subTask.finished);
        const filteredTaskss = forFilter
            .filter((subTask) => {
                let isVisible = true;
                if (projectId) {
                    isVisible = subTask.subTask.project === projectId;
                }
                if (cycleId) {
                    isVisible = isVisible && (subTask.subTask.cycle === cycleId);
                }
                if (assignedTo) {
                    isVisible = isVisible && (subTask.subTask.assignedTo === assignedTo);
                }
                return isVisible;
            })
        if (filteredTaskss.length > 0) {
            this.setState({ filteredTasks: filteredTaskss, filtering: false }, () => prepareFilters(this.state.filteredTasks)
                .then(filters => {
                    const [projects, cycles, workers] = filters;
                    this.setState({ projects, cycles: cycles.filter(c => c), workers });
                }));
        } else {
            this.setState({ filtering: false }, () => {
                toast.error("No filter result for given data!", {
                    position: "top-center",
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                });
            })
        }
    }

    handleChange = name => selected => {
        if (selected !== null && name === 'date') {
            this.setState({
                startDate: selected.startDate,
                endDate: selected.endDate
            })
        }
        this.setState({ [name]: selected && selected.value }, () => {
            const { tasks, projectId, cycleId, assignedTo, startDate, endDate, finished, filteredTasks } = this.state;
            let fromDate = startDate ? startDate.format('YYYY-MM-DD') : null;
            let toDate = endDate ? endDate.format('YYYY-MM-DD') : null;
            let forFilter;
            if (finished) {
                forFilter = tasks;
            } else {
                forFilter = tasks.filter((t) => !t.subTask.finished);
            }
            const filteredTaskss = forFilter
                .filter((subTask) => {
                    let isVisible = true;
                    if (projectId) {
                        isVisible = subTask.subTask.project === projectId;
                    }
                    if (cycleId) {
                        isVisible = isVisible && (subTask.subTask.cycle === cycleId);
                    }
                    if (assignedTo) {
                        isVisible = isVisible && (subTask.subTask.assignedTo === assignedTo);
                    }
                    if (fromDate !== null && toDate !== null) {
                        isVisible = isVisible && (subTask.subTask.endDate ? subTask.subTask.endDate >= fromDate && subTask.subTask.endDate <= toDate : false);
                    }
                    if (finished === true) {
                        isVisible = isVisible && (subTask.subTask.finished === finished);
                    } else if (finished === false || finished === 0) {
                        isVisible = isVisible && (!subTask.subTask.finished)
                    }
                    return isVisible;
                })
            if (filteredTaskss.length > 0) {
                this.setState({ filteredTasks: filteredTaskss, filtering: false }, () => prepareFilters(this.state.filteredTasks)
                    .then(filters => {
                        const [projects, cycles, workers] = filters;
                        this.setState({ projects, cycles: cycles.filter(c => c), workers });
                    }));
            } else {
                this.setState({ filtering: false }, () => {
                    toast.error("Kein passendes Task gefunden!", {
                        position: "top-center",
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                    });
                })
            }
        });
    };

    handleOverlayClose = () => {
        this.setState({ selectedProject: null, selectedCycle: null, selectedTask: null });
    };

    isDisabled = (manager, assignedTo) => {
        const { auth } = this.props;
        const { userRoles } = this.state;
        if (userRoles.length > 0) {
            return userRoles.some((member) => {
                if (Object.values(member)[0][0] === 'manager' || Object.values(member)[0][0] === 'co-manager' || window.btoa(auth.email) === manager) {
                    return false;
                } else if (window.btoa(auth.email) === assignedTo) {
                    return false;
                } else {
                    return true;
                }
            })
        } else {
            if (window.btoa(auth.email) === assignedTo) {
                return false
            } else {
                return true;
            }
        }
    }

    renderManagers = (members, manager) => {
        return Object.keys(members).map((member, i) => {
            if (members[member] === 'manager' && member !== manager) {
                return window.atob(member) + ' '
            }
        })
    }

    render() {
        const { classes, overlayLevel, onTagsOpen } = this.props;
        const { projects, filtering, cycles, workers, filteredTasks, tasks, state, projectId, cycleId, assignedTo, selectedProject, selectedCycle, selectedTask, role, row, title } = this.state;
        const renderedTasks = _.uniqWith(filteredTasks, _.isEqual).map((task) => {
            if (task === undefined || task.length === 0 || !task.cycles) {
                return null;
            }
            const index = task.cycles ? task.cycles.index + 1 : 0;
            const badgeContent = Object.keys(task.project.members).filter(function (member) { return task.project.members[member] === 'manager' && task.task.manager !== member }).length ?
                Object.keys(task.project.members).filter(function (member) { return task.project.members[member] === 'manager' && task.task.manager !== member }).length : '';
            return <TableRow>
                <CustomTableCell>
                    <div className={classes.editButton}>
                        <Button
                            color="primary"
                            aria-label="Add"
                            disabled={this.isDisabled(task.task.manager, task.subTask.assignedTo)}
                            onClick={() => this.onEditClick(task, task.project.title, task.task.manager, task.project.members, task.subTask.assignedTo)}
                        >
                            <Typography color="primary">
                                {task.task.name}
                            </Typography>
                        </Button>
                    </div>
                </CustomTableCell>
                <CustomTableCell>{task.subTask.createdOn ? (new Date(task.subTask.createdOn)).toLocaleDateString('de-AT') : '/'}</CustomTableCell>
                <CustomTableCell>{task.project.title}</CustomTableCell>
                <CustomTableCell>{'[' + index + '] ' + task.cycles.title}</CustomTableCell>
                <CustomTableCell>{task.subTask.endDate ? task.subTask.endDate : '/'}</CustomTableCell>
                <CustomTableCell>{window.atob(task.subTask.assignedTo)}</CustomTableCell>
                <CustomTableCell>{window.atob(task.task.manager)}
                    {badgeContent &&
                        <Tooltip title={this.renderManagers(task.project.members, task.task.manager)}>
                            <Badge className={classes.badge} badgeContent={badgeContent} color="primary" style={{ zIndex: '1' }}>
                                <Typography>
                                    {}
                                </Typography>
                            </Badge>
                        </Tooltip>
                    }
                </CustomTableCell>
            </TableRow>
        })

        if (filtering === true) {
            return <LoadingProgress />
        }
        return (
            <div className={classes.container} >
                <div className={classes.filter}>
                    <div className={classes.filter}>
                        <Select
                            isClearable
                            isMulti={false}
                            value={projects.find(function (element) {
                                return element.value === projectId;
                            })}
                            onChange={this.handleChange('projectId')}
                            closeMenuOnSelect={false}
                            className={classes.select}
                            placeholder='Projekt'
                            options={projects}
                        />
                        <Select
                            isClearable
                            isMulti={false}
                            value={cycles.find(function (element) {
                                return element.value === cycleId;
                            })}
                            onChange={this.handleChange('cycleId')}
                            closeMenuOnSelect={false}
                            className={classes.select}
                            placeholder='Cycle'
                            options={cycles}
                        />
                        <Select
                            isClearable
                            isMulti={false}
                            value={workers.find(function (element) {
                                return element.value === assignedTo;
                            })}
                            onChange={this.handleChange('assignedTo')}
                            closeMenuOnSelect={false}
                            className={classes.select}
                            placeholder='Bearbeiter'
                            options={workers}
                        />
                        <Select
                            isClearable
                            isMulti={false}
                            closeMenuOnSelect={false}
                            className={classes.select}
                            placeholder='Status'
                            options={state}
                            onChange={this.handleChange('finished')}
                        />
                        <div className={classes.picker}>
                            <DateRangePicker
                                className='picker'
                                startDate={this.state.startDate}
                                startDateId="START_DATE"
                                endDate={this.state.endDate}
                                endDateId="END_DATE"
                                onDatesChange={this.handleChange('date')}
                                focusedInput={this.state.focusedInput}
                                onFocusChange={focusedInput => this.setState({ focusedInput })}
                                numberOfMonths={1}
                                minimumNights={0}
                                isOutsideRange={() => false}
                                customArrowIcon={' '}
                                showClearDates
                                displayFormat="DD.MM.YYYY"
                                startDatePlaceholderText={'Erstellt'}
                                endDatePlaceholderText={'Fällig'}
                            />
                        </div>
                    </div>
                </div>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <CustomTableCell >Task</CustomTableCell>
                            <CustomTableCell >Erstellt</CustomTableCell>
                            <CustomTableCell >Projekt</CustomTableCell>
                            <CustomTableCell >Cycle & Titel</CustomTableCell>
                            <CustomTableCell >Fällig</CustomTableCell>
                            <CustomTableCell >Bearbeiter</CustomTableCell>
                            <CustomTableCell >Manager</CustomTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {renderedTasks}
                    </TableBody>
                </Table>
                {filteredTasks.length === 0 && !filtering &&
                    <Typography variant="display1" color="primary" style={{ textAlign: 'center' }}>Keine aufgaben!</Typography>
                }
                {(Boolean(selectedProject) && Boolean(selectedCycle) && Boolean(selectedTask) && Boolean(role))
                    && <OverlayContainer onTagsOpen={onTagsOpen} projectId={selectedProject} cycleId={selectedCycle} taskId={selectedTask} role={role} onOverlayClose={this.handleOverlayClose} row={row} title={title} overlayLevel={overlayLevel || 0} />}
            </div>
        );
    }
}


export default withStyles(styles)(connect(state => ({
    auth: state.firebase.auth,
}))(TasksDashboard));



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksDashboard.js